<div class="update-supplier-form">
  <div class="update-supplier-form-body">
    <div class="d-flex content" #updateCustomerContainer>
      <!-- Start Left Content -->
      <div class="ui-g-7 supplier" [ngClass]="{ 'sidebar-disable': !supplier.isActive }">
        <!-- archived msg -->
        <div *ngIf="!supplier.isActive" class="ui-g-12 p-0 pl-4 pr-4 mt-4 font-16">
          This supplier has been archived due to the QBO integration
        </div>
        <!-- Supplier name -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-4">
          <app-input
            id="fleet-name"
            validationId="error-supplier-name"
            placeholder="Supplier name*"
            [disabled]="supplier?.type?.value === 'online'"
            [errorMessage]="validate.supplierName"
            [isInvalid]="validate.supplierName"
            [value]="supplier.supplierName"
            [floatingLabel]="true"
            [maxLength]="75"
            (appChange)="handleChange('supplierName', $event)"
            (appFocus)="handleFocus('supplierName')"
          ></app-input>
        </div>

        <!-- Display Name -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="">
            <app-input
              id="display-name"
              validationId="error-display-name"
              placeholder="Display name*"
              [disabled]="supplier?.type?.value === 'online'"
              [errorMessage]="validate.name"
              [isInvalid]="validate.name"
              [value]="supplier.name"
              [floatingLabel]="true"
              [maxLength]="75"
              (appChange)="handleChange('name', $event)"
              (appFocus)="handleFocus('name')"
            ></app-input>
          </div>
        </div>

        <!-- Payment term and account num -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30" *ngIf="isAccountPayablePayment">
          <div class="ui-g-6 pl-0">
            <app-dropdown
              id="term-type"
              listId="term-type"
              placeholder="Payment Term"
              theme="primary"
              field="label"
              [value]="{ label: supplier?.accPayableTerm?.name }"
              [fontSize]="14"
              [listItemFontSize]="13"
              [floatingLabel]="true"
              [options]="paymentTerms"
              [isDropdownIconVisible]="true"
              (appSelect)="handleChange('accPayableTerm', $event)"
            >
            </app-dropdown>
          </div>
          <div class="ui-g-6 pr-0">
            <app-input
              id="fleet-name"
              validationId="error-fleet-name"
              placeholder="Account number"
              [errorMessage]="validate.accountNumber"
              [isInvalid]="validate.accountNumber"
              [value]="supplier.accountNumber"
              [floatingLabel]="true"
              [maxLength]="75"
              (appChange)="handleChange('accountNumber', $event)"
              (appFocus)="handleFocus('accountNumber')"
            ></app-input>
          </div>
        </div>

        <!-- Supplier Id -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="">
            <app-input
              id="supplierId"
              validationId="error-supplierId"
              placeholder="Supplier ID"
              [errorMessage]="validate.supplierId"
              [isInvalid]="validate.supplierId"
              [value]="supplier.supplierId"
              [floatingLabel]="true"
              [maxLength]="75"
              (appChange)="handleChange('supplierId', $event)"
              (appFocus)="handleFocus('supplierId')"
            ></app-input>
          </div>
        </div>

        <!-- Payment term and account num -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30" *ngIf="isAccountPayablePayment && (supplier?.type?.value === 'online' || supplier?.type?.value === 'sublet')">
          <app-auto-complete
            id="qbo-type"
            textAreaId="qbo-type"
            listId="qbo-type"
            placeholder="Internal supplier reference*"
            label="Internal supplier reference"
            theme="inline"
            scrollHeight="160px"
            field="qbo-type"
            [suggestions]="getSupplierNames()"
            [floatingLabel]="true"
            [fontSize]="14"
            [closeOnSelection]="true"
            [value]="selectedSupplierName"
            (appSelect)="selectSupplierRef($event)"
            (appCompletedMethod)="onInternalSupplierSearch($event)"
            (appClear)="onInternalSupplierClear()"
            (appFocus)="showSuggestions('qboResponse')"
          >
            <ng-template let-item appTemplate="editable">
              <div id="est-add-customer" class="p-1 flex-start-center" (click)="craeteNewSupplier()">
                <span class="font-12">+ Create new supplier in QBO</span>
              </div>
            </ng-template>
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">{{ item.name }}</div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <!-- Contact info -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="ui-g-6">
            <app-input
              id="phone-0"
              validationId="error-phone"
              placeholder="Phone"
              mask="(000) 000-0000"
              [value]="supplier?.phones ? supplier?.phones[0]?.value : ''"
              [floatingLabel]="true"
              (appChange)="handleMultiChange('phones', 'value', 0, $event)"
              (appFocus)="handleMultiFocus('phones', 'value', 0, true)"
              (appBlur)="handleMultiFocus('phones', 'value', 0, false)"
            ></app-input>
          </div>

          <div class="ui-g-6">
            <app-input
              id="supplier-email-id"
              placeholder="Email"
              theme="primary"
              field="label"
              [value]="supplier?.emails ? supplier?.emails[0]?.value : ''"
              [fontSize]="14"
              [floatingLabel]="true"
              (appChange)="handleMultiChange('emails', 'value', 0, $event)"
              (appFocus)="handleMultiFocus('emails', 'value', 0, true)"
              (appBlur)="handleMultiFocus('emails', 'value', 0, false)"
            >
            </app-input>
          </div>
        </div>

        <div class="ui-g-12 p-0 pl-4 pr-4">
          <span class="flex-start-center pointer font-primary mt-1" (click)="openContactUpdateDialog()">
            <i class="fal fa-window"></i>
            <span class="font-12 pl-1">View and edit contacts</span>
          </span>
        </div>

        <!-- URL -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="">
            <app-input
              id="display-name"
              validationId="error-display-name"
              placeholder="URL"
              [errorMessage]="validate.url"
              [isInvalid]="validate.url"
              [value]="supplier.url"
              [floatingLabel]="true"
              [maxLength]="75"
              (appChange)="handleChange('url', $event)"
              (appFocus)="handleFocus('URL')"
              (appBlur)="handleBlur('url')"
            >
            </app-input>
          </div>
        </div>

        <!-- Warehouse address -->
        <div class="ui-g-12 p-0 pl-4 pr-4 p-relative mt-30">
          <div class="">
            <app-input
              id="address-1"
              [placeholder]="supplier?.type?.value === 'sublet' ? 'Shop address' : 'Warehouse address'"
              [value]="supplier?.wareHouseAddress?.addLine1"
              [floatingLabel]="true"
              [maxLength]="160"
              (appChange)="handleChange('wareHouseAddress-addLine1', $event)"
              (appFocus)="handleFocus('addLine1')"
            ></app-input>
          </div>
        </div>

        <!-- warehouse Zip Code -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="ui-g-6">
            <app-input
              id="zip-1"
              validationId="error-zip-1"
              placeholder="Zip"
              [errorMessage]="validate.zip"
              [isInvalid]="validate.zip"
              [value]="supplier?.wareHouseAddress?.zip"
              [floatingLabel]="true"
              [maxLength]="7"
              (appChange)="handleChange('wareHouseAddress-zip', $event)"
              (appFocus)="handleFocus('zip')"
              (appBlur)="zipChange($event, 'wareHouseAddress')"
            ></app-input>
          </div>

          <div class="ui-g-6">
            <app-auto-complete
              id="city-1"
              textAreaId="city-1"
              listId="list-city-1"
              placeholder="Search city"
              label="City"
              field="city"
              theme="inline"
              scrollHeight="160px"
              [floatingLabel]="true"
              [fontSize]="14"
              [closeOnSelection]="true"
              [value]="renderCityName(supplier?.wareHouseAddress?.city, supplier?.wareHouseAddress?.stateCode)"
              [suggestions]="addressCityResults"
              (appSelect)="onAddressCitySelect($event)"
              (appCompletedMethod)="addressCitySearch($event)"
              (appClear)="onAddressCityClear()"
            >
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">{{ item.city }}, {{ item?.stateCode }}</div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <!-- billing address -->
        <div class="ui-g-12 p-0 pl-4 pr-4 p-relative mt-30">
          <div class="">
            <app-input
              id="address-2"
              placeholder="Billing address"
              [value]="supplier?.billingAddress?.addLine1"
              [floatingLabel]="true"
              [maxLength]="160"
              (appChange)="handleChange('billingAddress-addLine1', $event)"
              (appFocus)="handleFocus('billingAddress')"
            ></app-input>
          </div>
        </div>

        <!-- warehouse Zip Code -->
        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30">
          <div class="ui-g-6">
            <app-input
              id="zip-2"
              validationId="error-zip-2"
              placeholder="Zip"
              [errorMessage]="validate.zip2"
              [isInvalid]="validate.zip2"
              [value]="supplier?.billingAddress?.zip"
              [floatingLabel]="true"
              [maxLength]="7"
              (appChange)="handleChange('billingAddress-zip', $event)"
              (appFocus)="handleFocus('zip2')"
              (appBlur)="zipChange($event, 'billingAddress')"
            ></app-input>
          </div>

          <div class="ui-g-6">
            <app-auto-complete
              id="city-2"
              textAreaId="city-2"
              listId="list-city-2"
              placeholder="Search city"
              label="City"
              theme="inline"
              scrollHeight="160px"
              field="city"
              [suggestions]="bAddressCityResults"
              [floatingLabel]="true"
              [fontSize]="14"
              [closeOnSelection]="true"
              [value]="renderCityName(supplier?.billingAddress?.city, supplier?.billingAddress?.stateCode)"
              (appSelect)="onBaddressCitySelect($event)"
              (appCompletedMethod)="bAddressCitySearch($event)"
              (appClear)="onBaddressCityClear()"
            >
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">{{ item.city }}, {{ item?.stateCode }}</div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30 pb-3">
          <div class="">
            <app-textarea
              textAreaId="supplier-update-notes"
              name="notes"
              placeholder="Pinned notes"
              theme="primary"
              [maxLength]="2000"
              [floatingLabel]="true"
              [value]="supplier.notes"
              [rows]="3"
              [autoGrow]="true"
              [maxAutoGrowHeight]="68"
              [autoFocus]="focus?.notes"
              (appChange)="handleChange('notes', $event)"
            >
            </app-textarea>
          </div>
        </div>

        <div class="ui-g-12 p-0 pl-4 pr-4 mt-30" *ngIf="isAppleDevice">
          <div class="iphone-dummy-height"></div>
        </div>
      </div>
      <!-- End Left Panel -->

      <!-- Start Right Panel -->
      <div class="ui-g-5 other p-0">
        <app-upcoming-supplier-pos [user]="supplier" [accPayable]="isAccountPayablePayment"> </app-upcoming-supplier-pos>
      </div>
      <!-- End Right Panel -->
    </div>
  </div>

  <div class="update-supplier-footer text-right">
    <button id="supplier-update-btn-save" class="btn btn-primary btn-submit px-4" [disabled]="isProcessing" (click)="onSubmit()">
      <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
      <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
    </button>
  </div>
</div>
